export default {
  data: function () {
    return {
      locked: false,
      top: null
    }
  },
  methods: {
    lockScrolling: function (ignoreTop) {
      this.locked = true
      this.top = document.body.scrollTop || document.documentElement.scrollTop
      document.body.className = 'lock-scrolling'
      if (ignoreTop !== true) {
        document.body.style.top = `-${this.top}px`
      }
    },
    unlockScrolling: function (scroll) {
      if (!this.locked && !document.body.className.includes('lock-scrolling')) {
        return
      }

      this.locked = false
      document.body.className = ''
      document.body.style.top = 0

      if (this.top !== null) {
        window.scrollTo(0, this.top)
      }

      this.top = null
    }
  }
}
